import { useTheme } from '@emotion/react'
import { Image } from '@mui/icons-material'
import { Container, Grid, List, ListItem, ListItemButton, ListItemText } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Box } from '@mui/system'
import React, { useRef, useState } from 'react'




export default function PrivacyCenter() {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const refTitlePrivacyCenter = useRef(null)
    const theme = useTheme()
    const classes = useStyles()
    const staticText = <div >
        <div ref={refTitlePrivacyCenter}>
            <h1 className={classes.h1}>นโยบายความเป็นส่วนตัว</h1>
        </div>
        <div >
            <p>
                นโยบายความเป็นส่วนตัว ลิง เป็นแพลตฟอร์ม ที่ พัฒนาขึ้นโดย บริษัท แอ ล ไอเอ็น จี (ประเทศไทย) จำกัด สำหรับการจัดเก็บและบริหารจัดการพื้นที่เพื่อให้ศึกษาภาคการเกษตรเท่านั้น นโยบายความเป็นส่วนตัวนี้ ได้อธิบายถึงการปฏิบัตของเราในเรื่องของข้อมูลส่วนบุคคลและข้อมูลนิรนาม (ตามคำจำกัดความด้านล่าง) ที่เราได้รับรวบรวมจากผู้ใช้บริการโปรแกรมของเราผ่านโทรศัพท์มือถือ การใช้ข้อมูลที่ถูกรวบรวมผ่านการใช้บริการของเรานั้น ได้ถูกจำกัดถึงวัตถุประสงค์ของการจัดเตรียมบริการสำหรับผู้ใช้งาน ซึ่งคุณได้มิส่วนร่วมกับลิง นโยบายความเป็นส่วนตัวนี้รับประกันลิงมีวิธีการรวบรวม การดำเนินการ การใช้งาน การเผยแพร่ และการป้องกันความปลอดภัยของข้อมูลส่วนตัวที่คุณได้รับบุคคลอย่างไรสำหรับวัตถุประสงค์ของนโยบายความเป็นส่วนตัวนี้

                ข้อมูลส่วนตัวนั้นควรหมายถึงข้อมูลต่างๆ ที่เกี่ยวกับการระบุความเป็นตัวตนหรือข้อมูลส่วนบุคคล โดยการยินยอมหรือการสร้างข้อมูลส่วนบุคคลและข้อมูลนิรนามผ่านโปรแกรมโทรศัพท์มือถือของเรานั้น คุณได้เห็นด้วยกับนโยบายความเป็นส่วนตัวนี้และคุณยอมตนอย่างชัดเจนถึงการดำเนินการของข้อมูลส่วนบุคคลและข้อมูลนิรนามของคุณในการยอมรับร่วมกันกับนโยบายความเป็นส่วนตัวนี้
            </p>
        </div>
    </div>


    return <><Container className={classes.container}>
        <Grid container>
            <Grid item xs={12} md={3}>
                <Box sx={{ position: { md: 'fixed' }, maxWidth: 300, width: { lg: '100%' } }}>
                    <List>
                        <ListItem>
                            <img src={require("../../assets/images/Logo.png")} />
                        </ListItem>
                        <ListItem selected={selectedIndex === 0}>
                            <ListItemButton onClick={() => {
                                refTitlePrivacyCenter.current.scrollIntoView({ behavior: "smooth" })
                                setSelectedIndex(0)
                            }}>
                                <ListItemText primary="นโยบายความเป็นส่วนตัว" />
                            </ListItemButton>

                        </ListItem>
                        {/* <ListItem selected={selectedIndex === 1}>
                            <ListItemButton onClick={() => {
                                refTitleCookiePolicy.current.scrollIntoView({ behavior: "smooth" })
                                setSelectedIndex(1)
                            }}>
                                <ListItemText primary="นโยบายการใช้งานคุกกี้" />
                            </ListItemButton>

                        </ListItem> */}

                    </List>

                </Box>

            </Grid>
            <Grid item xs={12} md={9} style={{ paddingLeft: 20, height: '100%' }}>
                {staticText}
            </Grid>
        </Grid>


    </Container></>
}

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: 70,
    },
    menu: {
        width: '100%'
    },
    detail: {

    },
    h1: {
        color: theme.palette.primary.main
    }
}))